import React from 'react'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export default function ContactUsForm() {

  const [values , setValues] = React.useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    
  })
  
  const handleChange = (prop) => (event) => {
    setValues({...values , [prop]: event.target.value});
  }
  
  
  const handleSubmit= async (event)=>{
    event.preventDefault();
    const body = {
      name:values.name,
      email:values.email,
      subject:values.subject,
      message:values.message
  }

  handleClose();

  console.log(body);

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  };
  
  try {
    const resp1 = await fetch('https://bhawna-jain-portfolio.herokuapp.com/sendContactData', requestOptions)

    if(resp1.ok){
      handleClick();
      // alert("submitted")
    }
    else
    // handleClicked();
      throw {msg: 'failed'}
  }
    
   catch (error) {
    console.log("Err ", error);
    error = (error.msg)?error.msg: "could not submit the form"; 
    // alert(error) ;
    handleClicked();
    
  }
}


const [open, setOpen] = React.useState(false);
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);


const [openPopUp, setOpenPopUp] = React.useState(false);
const [openPopUpError, setOpenPopUpError] = React.useState(false);

const handleClicked = () => {
setOpenPopUpError(true)
}


const handleClosePopError = (event, reason) => {
if (reason === 'clickaway') {
  return;
}

setOpenPopUpError(false);
};



const handleClick = () => {
setOpenPopUp(true);
};

const handleClosePop = (event, reason) => {
if (reason === 'clickaway') {
  return;
}

setOpenPopUp(false);
};




  return (

<>
<Snackbar open={openPopUp} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClosePop} severity="success" sx={{ width: '100%' }}>
              Sent Successfully
            </Alert>
          </Snackbar>

          <Snackbar open={openPopUpError} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClosePopError} severity="error" sx={{ width: '100%' }}>
              Something went wrong
            </Alert>
          </Snackbar>




    <div style={{marginTop : '20px' , marginRight : '200px'}} >
      
        <div className="contact" style={{width: '250px', paddingLeft: '30px'}}>
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom: '10px'}}>
              {/* <label htmlFor="fname">Name</label><br /> */}
              <TextField id="filled-basic" label="Name" variant="filled" style={{border: '1px solid white' , color : 'white' , width :'300px' }} value = {values.name} onChange={handleChange('name')} /> <br />
            </div>
            <div style={{marginBottom: '10px'}}>
            {/* <label htmlFor="fname">Email id </label><br /> */}
              <TextField id="filled-basic" label="Email Id" variant="filled" style={{border: '1px solid white' , color : 'white' , width :'300px' }} value = {values.email} onChange={handleChange('email')} /> <br />
            </div> 
            <div style={{marginBottom: '10px'}}>  
            {/* <label htmlFor="fname">Subject</label><br /> */}
              <TextField id="filled-basic" label="Subject" variant="filled" style={{border: '1px solid white' , color : 'white' , width :'300px' }} value = {values.subject} onChange={handleChange('subject')} /> <br />
            </div>
            {/* <label htmlFor="subject">Message</label> <br /> */}
            <TextField
          id="standard-multiline-static"
          label="Message"
          multiline
          rows={4}
          value = {values.message} onChange={handleChange('message')}
          variant="filled"
          style={{border : '1px solid white' , width : '300px' , color : 'white'}}
        />
            <div style={{marginTop: '10px'}}>
            <Button type='submit' variant="contained">Submit</Button>
            </div>
          </form> 
        </div>
      </div>
      </>
  )
}
